import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Dropdown from '@hellodarwin/core/lib/components/common/dropdown';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { AGENT_MODE_OPTIONS, } from '../../../constants/assistant.constants';
import { getModelOptionLabelStyle, ModelOptionContent, ModelOptionHeader, modelSelectorMenuStyles, } from '../model-selector/styles';
export const AgentModeSelector = ({ selectedMode, onModeChange, disabled = false, }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const menuItems = AGENT_MODE_OPTIONS.map((option) => {
        var _a;
        return ({
            key: (_a = option.value) !== null && _a !== void 0 ? _a : 'none',
            label: (_jsxs(ModelOptionContent, { children: [_jsx(ModelOptionHeader, { children: _jsx(Typography, { style: getModelOptionLabelStyle(theme), children: t(option.labelKey) }) }), _jsx(Typography, { elementTheme: "body4", color: theme.colors.grey_2, children: t(option.descriptionKey) })] })),
            onClick: () => onModeChange(option.value),
        });
    });
    const selectedOption = AGENT_MODE_OPTIONS.find((option) => option.value === selectedMode);
    const buttonText = selectedOption
        ? t(selectedOption.labelKey)
        : t('assistant|agent_mode_none_label');
    return (_jsx(Dropdown, { items: menuItems, placement: "bottomRight", trigger: ['click'], ctaRender: () => (_jsxs(Button, { size: "extra-small", transparent: true, disabled: disabled, defaultStyle: theme.colors.grey_2, trailingIcon: _jsx(TabArrow, { size: 16, down: true }), children: [t('assistant|agent_mode_label'), ": ", buttonText] })), styles: modelSelectorMenuStyles }));
};
export default AgentModeSelector;
